import Vue from 'vue';
import Hotspot from './hotspot/components/Hotspot.vue';
import AppPagination from './pagination/Pagination.vue'
import ModalLink from '@/components/infoModal/ModalLink'

Vue.component("app-hotsopt", Hotspot)
Vue.component("app-pagination", AppPagination)
Vue.component("modal-link", ModalLink)
